export default "__VITE_ASSET__8gGdulzK__"